export default __webpack_public_path__ + "static/media/5.f6cc9340.jpg";